import requests from '@/utils/requests';

/**
 * 事件分析
 * @param {*} data
 */
export function trackEventAnalysis(data) {
  return requests({
    serviceName: 'track-service',
    url: '/v1/track/eventAnalysis',
    method: 'post',
    data
  });
}
